import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=1314c93a&scoped=true"
var script = {}
import style0 from "./InfoDetails.vue?vue&type=style&index=0&id=1314c93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1314c93a",
  null
  
)

export default component.exports